import { render, staticRenderFns } from "./ElemInput.vue?vue&type=template&id=31fe9568&"
import script from "./ElemInput.vue?vue&type=script&lang=js&"
export * from "./ElemInput.vue?vue&type=script&lang=js&"
import style0 from "./ElemInput.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports